{
  "label": "Streaming options",
  "close": "Close",
  "noLinksTitle": "No Streaming Options",
  "noLinksDescription": "We couldn't find links to this song on music streaming services."
}
